export const activePlaneGroup = {
    namespaced: false,
    state: {},
    getters: {
        PLANE_GROUP_LIST: (state, getters, rootState, rootGetters) => {
            const guidActiveProject = rootState.route.params.projectUUID;
            if(guidActiveProject)
                return rootGetters[`projectList/${guidActiveProject}/planeGroupList/SELF`];
            else
                return null;
        },
        PLANE_GROUP: (state, getters, rootState, rootGetters) => {
            const guidActiveProject = rootState.route.params.projectUUID;
            const uuidActivePlaneGroup = rootState.route.params.groupID;
            if(guidActiveProject && uuidActivePlaneGroup)
                return rootGetters[`projectList/${guidActiveProject}/planeGroupList/${uuidActivePlaneGroup}/SELF`];
            else
                return null;
        }
    },
    mutations: {},
    actions: {
        CREATE_PLANE_GROUP: async function (context, dataPlaneGroup) {
            const guidActiveProject = context.rootState.route.params.projectUUID;
            const idPlaneGroup = await context.dispatch(`projectList/${guidActiveProject}/CREATE_GROUP`, {
                data: dataPlaneGroup,
            }, {root: true})
            return idPlaneGroup;
        },
        UPDATE_VALUE_PARAMS: async function (context, newParams) {
            const guidActiveProject = context.rootState.route.params.projectUUID;
            const planeGroupID = context.rootState.route.params.groupID;
            context.commit(`projectList/${guidActiveProject}/planeGroupList/${planeGroupID}/VALUE_PARAMS`, newParams, {root: true})
        },
        DELETE_PLANE_GROUP: async function (context) {
            const guidActiveProject = context.rootState.route.params.projectUUID;
            const planeGroupID = context.rootState.route.params.groupID;
            await context.dispatch(`projectList/${guidActiveProject}/DELETE_GROUP`, planeGroupID, {root: true});
        }
    }
}
